import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

// Client and Device are two symmetric entry points onto the same session data;
// Analytics is the aggregate view across all of it.
const BASE_OPTIONS = [
  { key: "client", label: "Client", to: "/sessions/clients" },
  { key: "device", label: "Device", to: "/sessions/devices" },
  { key: "analytics", label: "Analytics", to: "/sessions/analytics" },
];

export function SessionsModeToggle({ active }) {
  const navigate = useNavigate();
  const { role } = useAuth();

  // Analytics is FleetAdmin-only (role_matrix: GET /analytics/sessions/summary
  // -> ADMIN), but the Client and Device pages that render this toggle are also
  // reachable by SupportEngineer and ReleaseManager. Filtered out rather than
  // merely hidden with CSS, so those roles are never shown a control that would
  // refuse them.
  const options = BASE_OPTIONS.filter(
    (opt) => opt.key !== "analytics" || role === "FleetAdmin",
  );

  return (
    <div className="inline-flex items-center bg-slate-100 border border-slate-200 rounded-full p-1 gap-1">
      {options.map((opt) => (
        <button
          key={opt.key}
          onClick={() => navigate(opt.to)}
          className={`text-xs font-semibold px-3.5 py-1.5 rounded-full transition-colors ${
            active === opt.key
              ? "bg-[#08148C] text-white"
              : "text-slate-500 hover:text-slate-800"
          }`}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
